var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 35,
  viewBox: "0 0 35 35"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  x: 0.5,
  y: 0.5,
  fill: "#e6e6e6",
  stroke: "#e4e4e4",
  rx: 8
}), /*#__PURE__*/React.createElement("g", {
  fill: "#333"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 14h1v11h-1zM17 14h1v11h-1zM20 14h1v11h-1zM8 10h19v1H8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 11h-1.324V9.378c0-.486-.331-.864-.757-.864H16.08c-.426 0-.757.378-.757.864V11H14V9.378C14 8.081 14.946 7 16.081 7h2.838C20.054 7 21 8.081 21 9.378z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.364 29h-8.728c-1.163 0-2.181-.936-2.278-2.06L10 10.095 11.455 10l1.357 16.847c.049.421.436.75.824.75h8.728c.436 0 .824-.375.824-.75L24.545 10l1.455.094-1.358 16.847C24.545 28.11 23.527 29 22.364 29"
})))));
export default SvgTrash;